import { computed } from '@ember/object';
import { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { isPresent } from '@ember/utils';
export default EmberDataBaseFragment.extend({
  intl: service(),
  accountName: attr('string'),
  accountNumberSuffix: attr('string'),
  accountType: attr('string'),
  bankName: attr('string'),
  currencyCode: attr('string'),
  token: attr('string'),
  display: attr('string'),
  webToken: attr('string'),
  // TODO(arp): Preferably web would send down correct casing, but for now, we are manually creating.
  accountTypeAsLabel: computed('accountType', function () {
    switch (this.accountType) {
      case 'CHECKING':
        return 'checking';
      case 'SAVINGS':
        return 'savings';
      case 'INVESTMENT':
        return 'investment';
      case 'BUSINESSCHECKING':
        return 'businessChecking';
      default:
        return 'checking';
      // Use checking as default so string translation works
    }
  }),
  // Chase Checking ......111
  displayName: computed('bankName', 'accountTypeAsLabel', 'accountNumberSuffix', 'display', function () {
    if (isPresent(this.display)) {
      return this.display;
    }
    return this.intl.t('locations.edit.locationSettings.bankAccount.accountLabel', {
      bankName: this.bankName,
      // eslint-disable-next-line square/no-translation-key-interpolation
      accountType: this.intl.t(`business.bankAccount.accountTypes.${this.accountTypeAsLabel}`),
      accountNumberSuffix: this.accountNumberSuffix
    });
  }),
  // Your current payment method is your Chase checking ending in 111
  currentPaymentMethod: computed('bankName', 'accountTypeAsLabel', 'accountNumberSuffix', function () {
    return this.intl.t('subscriptions.sub2.paymentMethods.payoutAdjustment.statement', {
      bankName: this.bankName,
      // eslint-disable-next-line square/no-translation-key-interpolation
      accountType: this.intl.t(`business.bankAccount.accountTypes.${this.accountTypeAsLabel}`),
      accountNumberSuffix: this.accountNumberSuffix
    });
  }),
  // Chase checking ending in 111
  currentPaymentMethodShort: computed('bankName', 'accountTypeAsLabel', 'accountNumberSuffix', function () {
    return this.intl.t('subscriptions.sub2.paymentMethods.payoutAdjustment.statementShort', {
      bankName: this.bankName,
      // eslint-disable-next-line square/no-translation-key-interpolation
      accountType: this.intl.t(`business.bankAccount.accountTypes.${this.accountTypeAsLabel}`),
      accountNumberSuffix: this.accountNumberSuffix
    });
  })
}).reopenClass({
  _modelNameForMigration: 'subscription-bank-account'
});